<template>
  <page-layout title="교육영상 카테고리 관리">
    <template v-slot:table>
      <LectureCategoryTable
        :data="data"
        :loading="loading"
        @change="changeUseYn"
        @refresh="refreshList"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LectureCategoryTable from "@/pages/Lecture/components/category/LectureCategoryTable.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "LectureCategory",
  components: {LectureCategoryTable, PageLayout},
  data() {
    return {
      paramsData: {},
      data: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId"
    })
  },
  mounted() {
    this.getLectureCategoryList({memberId: this.memberId, useYn: ""});
  },
  methods: {
    async getLectureCategoryList(params) {
      this.paramsData = params;
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/private/training/category", { params })
        if (data.length < 1) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    // 전체|노출|미노출 상태값 변경 시 재조회
    changeUseYn(useYn) {
      this.paramsData.useYn = useYn;
      this.getLectureCategoryList(this.paramsData);
    },
    refreshList() {
      this.getLectureCategoryList(this.paramsData);
    }
  }
}
</script>
